export default __webpack_public_path__ + "static/media/bg_light.e8dba09b.png";